<template>
	<div class = "shop-location-div">
		<div class = "shop-name">
			<img src = "../../assets/shop.png">
			<span>{{shopName == '' ?sShop.shopName:shopName}}</span>
		</div>
		<div class = "shop-location">
			{{shopAddress == '' ? sShop.shopAddress:shopAddress}}
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'ComShopLocation',
		computed: mapGetters(["sShop"]),
		props:{
			shopName:{
				type:String,
				default:''
			},
			shopAddress:{
				type:String,
				default:''
			},
		}
		
	}
</script>

<style scoped>
	.shop-location-div {
		width: 100%;
		height: 75px;
		padding: 10px 18px;
		background-color: #ffffff;
	}
	.shop-location-div>.shop-name>span {
		font-size: 17px;
		line-height: 17px;
		font-weight: 600;
		color: #363636;
		margin-left: 6px;
	}
	.shop-location-div>.shop-name>img {
		width: 15px;
		height: 15px;
	}
	.shop-location-div>.shop-location {
		font-size: 12px;
		line-height: 15px;
		width: 80%;
		color: #6b6b6b;
		
	}
	.shop-location-div .shop-name {
		display: inline-flex;
		align-items: center;
		padding-bottom: 5px;
	}
</style>
